var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-fourth-border" }, [
      _c("div", { staticClass: "payment-fourth-content-parent" }, [
        _c("img", {
          staticClass: "payment-fourth-img",
          attrs: { src: require("../../assets/payment-fourth-1x.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "payment-fourth-title" }, [
          _vm._v(
            "In the past 30 days, over 10,000 retailers on ShopVidi have used their net 60 terms"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-fourth-content" }, [
          _c("div", { staticClass: "payment-fourth-content-1" }, [
            _c("div", { staticClass: "payment-fourth-content-number" }, [
              _vm._v("$890")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-fourth-content-text" }, [
              _vm._v("Avg. Net Terms Used")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "payment-fourth-content-2" }, [
            _c("div", { staticClass: "payment-fourth-content-number" }, [
              _vm._v("$2099")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-fourth-content-text" }, [
              _vm._v("Est. Retail Value Of Inventory")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "payment-fourth-content-3" }, [
            _c("div", { staticClass: "payment-fourth-content-number" }, [
              _vm._v("$0")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-fourth-content-text" }, [
              _vm._v("Upfront Cost")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e85a52c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e85a52c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/payment-fourth.vue
// module id = null
// module chunks = 